import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Single, clearly named service for homepage enquiries.
 * Connects to the Amden backend today; can later be pointed at the
 * dedicated Amden CRM without touching the UI.
 */
export async function submitEnquiry(payload) {
  const { data } = await axios.post(`${API}/enquiries`, payload, {
    headers: { 'Content-Type': 'application/json' },
  });
  return data;
}

/**
 * Insights/newsletter subscriptions. Stored securely in the same CRM-ready
 * backend; can later be pointed at an email-marketing platform without
 * touching the UI.
 */
export async function subscribeToInsights(payload) {
  const { data } = await axios.post(`${API}/subscriptions`, payload, {
    headers: { 'Content-Type': 'application/json' },
  });
  return data;
}
